module.exports = __webpack_public_path__ + "static/media/3_owl.e8d738a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/3_owl.png
// module id = 117
// module chunks = 0